import * as _ from "lodash";
import { take } from "rxjs/internal/operators/take";
import * as moment from "moment";
import { ProductionShopFloorWorkOrders } from "src/app/services/service/DataProviders/ProductionShopFloorWorkOrders";

export default class PoNode {
  private woService: ProductionShopFloorWorkOrders;

  private tree;
  public poNumber = '';
  public level = 0; //на кой ред се намира в дървото
  public product = null; // продукта
  public quantity = 0;
  public po = null;
  public items = [];
  public ingredients = [];
  public itemsWithIngredients = [];

  public children = []; // списък с child PO

  constructor(
    po,
    level = 0,
    woService: ProductionShopFloorWorkOrders,
    tree,
  ) {
    this.po = po;
    this.level = level;
    this.woService = woService;
    this.tree = tree;
    this.poNumber = this.getDocumentNo();
    this.items = _.get(this, 'po.Items', []);
    this.ingredients = _.get(this, 'po.ItemIngredients', []);

    for(let i = 0; i < this.items.length; i++) {
      const theItem = this.items[i];
      let ingredients = [];
      for(let j = 0; j < this.ingredients.length; j++) {
        const theIngredient = this.ingredients[j];

        if(theItem['@odata.id'] === theIngredient.WorkOrderItem['@odata.id']) {
          ingredients.push(theIngredient);
        }
      }

      ingredients = _.orderBy(ingredients, 'LineOrd');

      this.itemsWithIngredients.push({
        item: theItem,
        ingredients,
      });
    }
  }

  public async init() {
    let poChildren = await this.getChildren();
    if (!poChildren) {
      return false;
    }

    return true;
  }

  private async getChildren() {
    let call = JSON.parse(JSON.stringify(this.woService.stateTemplate));

    call.filter.filters.push({
      field: "Parent",
      operator: "eq",
      value: "'General_Documents_Documents(" + this.po.DocumentId + ")'",
    });
    call.take = 1000;

    let res = <any>(
      await this.woService.filter(call).pipe(take(1)).toPromise()
    );

    this.children = res.value;
    return true;
  }

  public getDocumentNo() {
    return _.get(this.po, "DocumentNo", '');
  }


}
